import { ArticleHeading2, IconEdit16 } from '@cian/ui-kit';
import { numberToPrettyString } from '@cian/utils';

import { FC } from 'react';

import { IInfoDescriptionProps } from './types';

import * as styles from './InfoDescription.css';

export const InfoDescription: FC<IInfoDescriptionProps> = props => {
  const { area, workplaceCount } = props;

  return (
    <div className={styles['container']}>
      <ArticleHeading2 as="span" color="black_100" fontWeight="bold">
        {`Отдельный офис ${numberToPrettyString(area)} м² на ${numberToPrettyString(workplaceCount)} чел.`}
      </ArticleHeading2>
      <button className={styles['edit-button']}>
        <IconEdit16 color="primary_100" display="inline-block" />
      </button>
    </div>
  );
};

InfoDescription.displayName = 'InfoDescription';
